export const getLocale = async () => {
  // if we are on client side / თუ ბრაუზერიდან მიდის რექვესთი
  if (typeof window !== "undefined") {
    const cookies = document.cookie.split(";");
    const localeCookie = cookies.find((cookie) =>
      cookie.trim().startsWith("NEXT_LOCALE="),
    );
    return localeCookie ? localeCookie.split("=")[1] : "en";
  }

  // if we are on server side / თუ სერვერიდან მიდის რექვესთი
  try {
    const { cookies } = await import("next/headers");
    const cookieStore = cookies();
    const localeCookie = cookieStore.get("NEXT_LOCALE");
    return localeCookie?.value || "en";
  } catch (error) {
    return "en";
  }
};
